import { therapyPlanningAction } from '../../actions/constant';

const {
  REQUEST_VALIDATE_MDS_CSV_TEMPLATE,
  SUCCESS_VALIDATE_MDS_CSV_TEMPLATE,
  FAILURE_VALIDATE_MDS_CSV_TEMPLATE,
  LOADING_VALIDATE_MDS_CSV_TEMPLATE,
  RESET_VALIDATE_MDS_CSV_TEMPLATE,
} = therapyPlanningAction;

const initialState: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const validateMDSAssessmentCsv = (state = initialState, action: any) => {
  switch (action.type) {
    case SUCCESS_VALIDATE_MDS_CSV_TEMPLATE: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }

    case FAILURE_VALIDATE_MDS_CSV_TEMPLATE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case LOADING_VALIDATE_MDS_CSV_TEMPLATE:
      return {
        ...state,
        loading: true,
      };

    case RESET_VALIDATE_MDS_CSV_TEMPLATE:
      return {
        ...state,
        errorMessage: null,
      };
      
    default:
      return state;
  }
};
